import React, {useState, useContext} from 'react';
import CONFIG from '../../../../Core/CONFIG/CONFIG';
import styles from './GameCard.module.sass';
import { Link } from 'react-router-dom';
import GameInjector from '../../../screens/Game/GameInjector';
import { ConquerContext } from '../../../contexts/ConquerContext';

const GameCard = ({gameData = {}, onClick}) => {

    const thumbnail = CONFIG.vars.PUBLIC_FULL_URL + '/' + gameData.splashLandscape;

    return (
        <>
            <button onClick={() => {onClick?.(gameData)}}>
                <div className={styles.gameCard}>
                    <img src={thumbnail} />
                </div>
                <h4 className={styles.title}>{gameData.name}</h4>
                <div className={styles.playbutton}>PLAY</div>

            </button>
        </>
    )

};

export default GameCard;
